import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Home/Home.css';
import gox from '../../assets/gox.png';
import { createaccounts } from '../../action/createaccount';
import {useDispatch} from 'react-redux';
import RoundProgressButton from '../Home/progress1'

function Home({setData, data, setCurrentTab}) {

  const navigate = useNavigate();
  const dispatch = useDispatch()

  function handleSubmit(e){
    e.preventDefault()//this will prevent action without refreshing your page

    const form = new FormData(e.currentTarget) //this stores all the information on the input
  }

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [termsIsAccepted, setTermsIsAccepted] = useState(false);

  const isPage1Valid = firstName && lastName && email && phoneNumber && password && termsIsAccepted;

  

  // const [action, setAction] = useState('Continue');


  // const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);


  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const [progress, setProgress] = useState(0);

  const handleProgressClick = () => {
    setProgress(1);
  }
  


//  console.log(firstName, lastName, email, phoneNumber, password, termsIsAccepted)

 


 const handleCreateAccount = () => {

  if (firstName && lastName && email && phoneNumber && password && termsIsAccepted) {
    console.log(firstName, lastName, email, phoneNumber, password, termsIsAccepted)
    // dispatch(createaccounts(firstName, lastName, email, phoneNumber, password,))
    // navigate('/Home2')

    const newUser = {
      "first_name": firstName,
      "last_name": lastName,
      "email": email,
      "phone_number": phoneNumber,
      "password": password,
      "category": "company"
    }
    setData(newUser);

    setCurrentTab('page2')
  } else {

      console.log('flll the fields')
  }
 }
  return (
    <>
      <div className='banner d-flex'>
        <div className="left px-5 py-5">
          <div className='pb-5'> <h6>GOX Register</h6></div>
          <div>
            <div className='pt-5 pb-5'>
              <h1>Management-Focused Financial Solution</h1>
              <p>Lorem ipsum dolor sit amet consectetur. Lectus nulla sit interdum
                et feugiat odio. Lorem ipsum dolor sit amet consectetur. Lectus nulla sit
                interdum et feugiat odio.
              </p>
            </div>

            <div className='dynamic p-3'>
              <p>
                In the dynamic landscape of modern workplaces, HR stands as the guardian of culture and the champion of employee well-being. We see our mission as not just managing resources, but as stewards of an environment
                where each person's unique skills and perspectives are
                valued.
              </p>
              <div className='d-flex mt-5 '>
                <div className='mx-2'><img src={gox} alt="logo" /></div>
                <div>
                  <h6>Gox register</h6>
                  <p>Our mission</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container forms mt-5">
          <div className="">
            {/* Left Column with H1 and P Tag */}
            <div className="welcome col-md-6">
              <h1>Create your account</h1>
              <p>Enter details below to create account.</p>
            </div>
           
                   {/* Right Column with Form */}
        <div className="col-md-6">
          <form  onSubmit={(e) => handleSubmit(e)}>
            <div className="mb-3">
              <div className="row">
                <div className="col">
                  <label htmlFor="firstName" className="form-label">First Name</label>
                  <input type="text" className="form-control w-100" id="firstName" placeholder="First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                </div>
                <div className="col">
                  <label htmlFor="lastName" className="form-label">Last Name</label>
                  <input type="text" className="form-control" id="lastName" placeholder="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input type="email" className="form-control" id="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>

            <div className="mb-3">
              <label htmlFor="Phone number" className="form-label">Phone number</label>
              <input type="number" className="form-control" id="phonenumber" placeholder="Phone number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
            </div>

            <div className="mb-3 input-container">
              <label htmlFor="password" className="form-label">Password</label>
              <div className="input-with-icon">
              <input
                      type={passwordVisible ? 'text' : 'password'}
                      className="form-control"
                      id="password"
                      placeholder="Password"
                      onChange={handlePasswordChange}
                      value={password}
                    />
            <i
                      className={`fa ${passwordVisible ? 'fa-eye-slash' : 'fa-eye'}`}
                      id="togglePassword"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: 'pointer' }}>
            </i>
      </div>
             
            </div>
            <div className="mb-3 form-check">
              <input type="checkbox" className="form-check-input" id="acceptTerms" onChange={() => setTermsIsAccepted(!termsIsAccepted)}/>
              <label className="form-check-label" htmlFor="acceptTerms">I accept the terms and conditions</label>
            </div>
           
            {/* <Link to={{
              pathname: '/Home2',
              state:{
                firstName,
                lastName,
                email,
                phoneNumber,
                password,
                termsIsAccepted
              }
            }}>
              <button type="submit" className="btn btn1 w-100">Continue</button>
            </Link> */}

     {/* <Link to="/Home2"> */}
     <div  onClick={handleProgressClick}>
        <button type="submit" className="btn btn1 w-100 "  onClick={handleCreateAccount}>Continue</button>
      </div>
      {/* </Link> */}

      {isPage1Valid || (
        <div className="fill-in-all-forms">Fill in all forms on this page</div>
      )}


           
          </form>
          
          <div className="mt-3">
            <p>Already have an account? <a href="/">Sign in</a></p>
          </div>
            </div>
          </div>
        </div>

      <div className="progress-container">
      <RoundProgressButton progress={`${progress}/2`} />
     
    </div>



      </div>
    </>
  )
}

export default Home;
